import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "season-header" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = {
  key: 0,
  class: "content-box"
}

import {onMounted, ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchData} from "../utils/FetchData";
	import {SortArrayByObjectKey} from "../utils/Sorting";
	import RaceCard from '../components/RaceCard.vue';
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {

	const router = useRouter();
	const season = ref({});
	const loading = ref(true);
	const filterType = ref(0);
	const raceCount = ref([0, 0, 0]);
	const predictions = ref([]);
	const predictionsRace = ref(new Map());

	onMounted(() => {
		if(sessionStorage.token != undefined)
			retrieveSeason();
	});

	router.afterEach((to) => {
		if(!to.path.endsWith('/'))
			return;

		if(sessionStorage.token != undefined)
			retrieveSeason();
	});


	async function retrieveSeason() {
		loading.value = true;

		let id = 0
		const query = router.currentRoute.value.query;
		if(query.season != undefined) {
			id = parseInt(query.season);
		}

		if(id > 0) {
			const data = await FetchData("user/seasons/" + id);
			if(!data.isError)
				season.value = data.data;
		}
		else {
			const data = await FetchData("user/seasons");
			if(data.isError) {
				loading.value = false;
				return;
			}

			if(data.data.length > 0)
				season.value = data.latest;
		}

		if(Object.keys(season.value).length > 0) {
			retrievePredictions(season.value.id);

			let racesFinshed = season.value.races.filter(x => x.date <= Date.now() / 1000);
			let racesUpcoming = season.value.races.filter(x => x.date > Date.now() / 1000);

			raceCount.value = [season.value.races.length, racesUpcoming.length, racesFinshed.length];

			racesFinshed = SortArrayByObjectKey(racesFinshed, 'date', true);
			racesUpcoming = SortArrayByObjectKey(racesUpcoming, 'date');

			season.value.races = racesUpcoming.concat(racesFinshed);
		}

		loading.value = false;
	}

	async function retrievePredictions(seasonId: number) {
		const data = await FetchData('predictions/?season=' + seasonId);
		if(!data.isError) {
			predictions.value = data.data.predictions;

			season.value.races.forEach(race => {				
				const filter = predictions.value.filter(x => x.race_id == race.id);
				predictionsRace.value.set(race.id, filter);
			});

			/*if(data.data.length == 0)
				return;

			const player = JSON.parse(sessionStorage.player);
			if(player.id == undefined)
				return;

			let array = data.data.filter(x => x.player_id == player.id);
			array = SortArrayByObjectKey(array, 'position');

			for(let i = 0; i < array.length; i++)
				pickedDrivers.value[i] = array[i].driver_id;*/
		}
	}

	function changeFilter(type: number) {
		filterType.value = type;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(season.value.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["content-box", {selected: filterType.value == 0}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeFilter(0)))
      }, "Alles (" + _toDisplayString(raceCount.value[0]) + ")", 3),
      _createElementVNode("button", {
        class: _normalizeClass(["content-box", {selected: filterType.value == 1}]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeFilter(1)))
      }, "Komend (" + _toDisplayString(raceCount.value[1]) + ")", 3),
      _createElementVNode("button", {
        class: _normalizeClass(["content-box", {selected: filterType.value == 2}]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeFilter(2)))
      }, "Gereden (" + _toDisplayString(raceCount.value[2]) + ")", 3)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(season.value.races, (race) => {
      return (_openBlock(), _createBlock(RaceCard, {
        key: race,
        race: race,
        admin: false,
        season: 0,
        players: season.value.players,
        predictions: predictionsRace.value.get(race.id),
        circuits: undefined,
        class: _normalizeClass({hidden: (filterType.value == 1 && race.date <= Date.now() / 1000) || (filterType.value == 2 && race.date > Date.now() / 1000)})
      }, null, 8, ["race", "players", "predictions", "class"]))
    }), 128)),
    (season.value.id == undefined && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Geen seizoenen gevonden "))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true)
  ], 64))
}
}

})